import { Skeleton } from "@/components/ui/skeleton";

export function TableSkeleton({ rows = 8, cols = 10 }) {
  return (
    <div data-testid="table-skeleton" className="overflow-hidden rounded-2xl border border-sky/70 bg-white">
      <div className="space-y-0 divide-y divide-sky/40">
        <div className="flex gap-4 bg-mist px-4 py-3">
          {Array.from({ length: cols }).map((_, i) => <Skeleton key={i} className="h-3 flex-1 bg-navy/10" />)}
        </div>
        {Array.from({ length: rows }).map((_, r) => (
          <div key={r} className="flex items-center gap-4 px-4 py-3.5">
            {Array.from({ length: cols }).map((_, c) => (
              <Skeleton key={c} className={`h-4 flex-1 bg-navy/10 ${c === 0 ? "max-w-[140px]" : ""}`} />
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}

export function KanbanSkeleton({ columns = 5, cards = 4 }) {
  return (
    <div data-testid="kanban-skeleton" className="flex flex-1 gap-4 overflow-hidden pb-4">
      {Array.from({ length: columns }).map((_, c) => (
        <div key={c} className="flex w-[300px] flex-shrink-0 flex-col rounded-2xl border border-t-4 border-sky/60 border-t-slate-200 bg-mist/60">
          <div className="flex items-center justify-between px-4 py-3">
            <Skeleton className="h-4 w-24 bg-navy/10" />
            <Skeleton className="h-5 w-6 rounded-full bg-navy/10" />
          </div>
          <div className="space-y-2.5 px-2.5 pb-3">
            {Array.from({ length: cards }).map((_, k) => (
              <div key={k} className="space-y-2 rounded-xl border border-sky/70 bg-white p-3">
                <Skeleton className="h-4 w-3/4 bg-navy/10" />
                <Skeleton className="h-3 w-1/2 bg-navy/10" />
                <div className="flex gap-1.5"><Skeleton className="h-4 w-12 rounded-full bg-navy/10" /><Skeleton className="h-4 w-16 rounded-full bg-navy/10" /></div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export function ActivitySkeleton({ count = 6 }) {
  return (
    <div data-testid="activity-skeleton" className="grid grid-cols-1 gap-5 lg:grid-cols-3">
      {Array.from({ length: 3 }).map((_, col) => (
        <div key={col} className="space-y-3">
          <Skeleton className="mb-3 h-4 w-28 bg-navy/10" />
          {Array.from({ length: Math.ceil(count / 3) }).map((_, k) => (
            <div key={k} className="space-y-2 rounded-2xl border border-sky/70 bg-white p-4">
              <div className="flex gap-1.5"><Skeleton className="h-4 w-16 rounded-full bg-navy/10" /><Skeleton className="h-4 w-12 rounded-full bg-navy/10" /></div>
              <Skeleton className="h-4 w-2/3 bg-navy/10" />
              <Skeleton className="h-3 w-1/3 bg-navy/10" />
              <Skeleton className="h-10 w-full rounded-lg bg-navy/10" />
            </div>
          ))}
        </div>
      ))}
    </div>
  );
}
